import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import CallList from '../../assets/json/dummyDropDown.json';
import { Link } from 'react-router-dom';
import CustomLoadingOverlay from '../../shared/component/customLoadingOverlay';
import AddCallsForm from './addCallsForm';
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap';
import AddLogCallsForm from './addLogCallsForm';
import AddCallsNowForm from './addCallsNowForm';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import { getCallsList } from '../../redux/selector';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import Loader from '../../shared/component/Loader';
import { callInputData } from '../../shared/constants';

const OptionButton = ({ handleOpenEditForm, paramsValue }) => {
  return (
    <div className="action-menu">
      <img
        src="/assets/images/edit.png"
        className="action-img1"
        onClick={() => handleOpenEditForm(paramsValue)}
        alt="Edit Call"
        title="Edit Call"
      ></img>
      <Link to="/calls/viewCalls">
        <img
          src="/assets/images/view.png"
          className="action-img2"
          alt="View Call"
          title="View Call"
        ></img>
      </Link>
    </div>
  );
};

const initialValue = {
  callTo: '',
  relatedTo: '',
  callType: '',
  outgoingCallStatus: '',
  callStartTime: '',
  callOwner: '',
  callOwnerId: '',
  subject: '',
  reminder: '',
  callPurpose: '',
  callAgenda: '',
  createdBySystem: '',
  createdBySystemId: '',
  modifiedBySystem: '',
  modifiedBySystemId: '',
};

function Calls() {
  const stateData = useSelector((state) => state);
  const calls = useSelector(getCallsList);
  const dispatch = useDispatch();
  let storeLoading = isLoadingByKey(stateData, 'callsList');
  const themeValue = localStorage.getItem('selectedGridTheme');
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [selectedTheme, setSelectedTheme] = useState(themeValue ? themeValue : 'alpine');
  const [gridLoading, setGridLoading] = useState(false);
  const gridRef = useRef();
  const [open, setOpen] = React.useState(false);
  const [openLog, setOpenLog] = useState(false);
  const [openNow, setOpenNow] = useState(false);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [rowData, setRowData] = useState(calls);
  const [callData, setCallData] = useState();
  const [activeMenu, setActiveMenu] = useState(null);
  const [loading, setLoading] = useState(storeLoading);
  const [updateListFlag, setUpdateListFlag] = useState(false);
  const dropdownRef = useRef(null);

  const toggleFirstDropdown = () => {
    setActiveMenu(activeMenu === 'first' ? null : 'first');
  };

  const toggleSecondDropdown = () => {
    setActiveMenu(activeMenu === 'second' ? null : 'second');
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveMenu(null);
    }
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: 'Actions',
      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return (
          <OptionButton
            rowData={paramsValue}
            openPopup={open}
            handleOpenEditForm={() => handleOpenEditForm(paramsValue)}
          />
        );
      },
      maxWidth: 120,
      sortable: false,
      filter: false,
    },

    {
      headerName: 'Call To',
      field: 'callTo',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Subject',
      field: 'subject',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Call Purpose',
      field: 'callPurpose',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Call Start Time',
      field: 'startTime',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Reminder',
      field: 'reminder',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Outgoing Call Status',
      field: 'outgoingCallStatus',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },

    {
      headerName: 'Call Type',
      field: 'callType',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Created By',
      field: 'createdBy',
      minWidth: 230,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Updated By',
      field: 'updatedBy',
      minWidth: 230,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
  ]);

  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        { statusPanel: 'agTotalRowCountComponent', align: 'center' },
        { statusPanel: 'agFilteredRowCountComponent' },
        { statusPanel: 'agSelectedRowCountComponent' },
        { statusPanel: 'agAggregationComponent' },
      ],
    };
  }, []);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const popupParent = useMemo(() => {
    return document.body;
  }, []);

  const sortingOrder = useMemo(() => {
    return ['desc', 'asc', null];
  }, []);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 130,
    filter: true,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
  }));

  const refresh = () => {
    setGridLoading(true);
  };

  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setQuickFilter(document.getElementById('filter-text-box').value);
  }, []);

  const handleFormSubmit = (formData) => {
    console.log(formData);
  };

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: 'left',
    };
  }, []);

  const handleOpenAddForm = () => {
    const updatedObject = {
      ...initialValue,
      type: 'add',
    };
    setCallData(updatedObject);
    setOpen(true);
  };

  const handleOpenEditForm = (paramsValue) => {
    const updatedObject = {
      ...paramsValue,
      type: 'edit',
    };
    setCallData(updatedObject);
    setOpen(true);
  };

  const handleOpenLogCallsForm = () => {
    setOpenLog(true);
  };
  const handleCloseLogForm = () => {
    setOpenLog(false);
  };
  const handleOpenCallNowForm = () => {
    setOpenNow(true);
  };
  const handleCloseCallNowForm = () => {
    setOpenNow(false);
  };

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage();
  }, []);

  const cellClickedListener = useCallback((event) => {}, []);
  const handleCloseAddForm = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (calls && calls.length === 0) {
      setUpdateListFlag(true);
    } else {
      setRowData(calls);
    }
  }, [calls]);

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    // Check if assignments contain data
    if (calls && calls.length > 0) {
      setRowData(calls);
    } else {
      setRowData([]);
    }
  }, [calls]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (updateListFlag) {
      const columnName = updateListFlag === false ? 'name' : 'UpdatedDateTime';
      const orderType = updateListFlag === false ? 'asc' : 'desc';
      const data = {
        ColumnName: columnName,
        OrderType: orderType,
        PageNumber: 1,
        PageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
      };
      setUpdateListFlag(false);
      dispatch(fetchDataAndUpdateStore({ key: 'callsList', inputData: callInputData }));
    }
  }, [dispatch, updateListFlag]);

  return (
    <>
      {loading && <Loader />}
      <div className="inner-page" style={containerStyle}>
        <div className="dash-container">
          <div className="tbl_container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="main-hd">
                  <div className="pagetitle">
                    <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                    Calls
                  </div>

                  <div className="third-div">
                    <img
                      className="refresh-btn"
                      src="/assets/images/refresh.svg"
                      alt="Refresh"
                      onClick={refresh}
                    />
                    <div className="heading_item">
                      <input
                        className="form-control"
                        id="filter-text-box"
                        type="Text"
                        placeholder="Search in Calls..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>

                    <div className="heading_item">
                      <Dropdown as={ButtonGroup} show={!!activeMenu} ref={dropdownRef}>
                        <Button
                          className="add-grp-btn"
                          variant="success"
                          type="button"
                          onClick={toggleFirstDropdown}
                        >
                          Create Call
                        </Button>

                        <Dropdown.Toggle
                          split
                          variant="success"
                          id="dropdown-split-basic"
                          className="add-grp-btn"
                          onClick={toggleSecondDropdown}
                        />

                        <Dropdown.Menu show>
                          {activeMenu === 'first' && (
                            <>
                              <Dropdown.Item onClick={handleOpenAddForm}>
                                Schedule a call
                              </Dropdown.Item>
                              <Dropdown.Item onClick={handleOpenLogCallsForm}>
                                Log a call
                              </Dropdown.Item>
                              <Dropdown.Item onClick={handleOpenCallNowForm}>
                                Call Now
                              </Dropdown.Item>
                            </>
                          )}
                          {activeMenu === 'second' && (
                            <>
                              <Dropdown.Item href="#/action-4">Import Call</Dropdown.Item>
                              <Dropdown.Item href="#/action-5">Import Notes</Dropdown.Item>
                            </>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>

                      {open && (
                        <div className={`overlay ${isOverlayVisible ? 'visible' : ''}`}>
                          {' '}
                          <AddCallsForm
                            handleCloseAddForm={handleCloseAddForm}
                            handleFormSubmit={handleFormSubmit}
                            handleOpenEditForm={handleOpenEditForm}
                            callData={callData}
                            open={open}
                            callList={CallList}
                          />{' '}
                        </div>
                      )}
                      {openLog && (
                        <div className={`overlay ${isOverlayVisible ? 'visible' : ''}`}>
                          {' '}
                          <AddLogCallsForm
                            handleCloseLogForm={handleCloseLogForm}
                            callData={callData}
                            openLog={openLog}
                            callList={CallList}
                          />{' '}
                        </div>
                      )}
                      {openNow && (
                        <div className={`overlay ${isOverlayVisible ? 'visible' : ''}`}>
                          {' '}
                          <AddCallsNowForm
                            handleCloseLogForm={handleCloseCallNowForm}
                            callData={callData}
                            openNow={openNow}
                            callList={CallList}
                          />{' '}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="cutome_ag_theme">
                  <div
                    className={`ag-theme-${selectedTheme} tbl_height`}
                    style={{ width: '100%', height: `100%` }}
                  >
                    {gridLoading ? (
                      <CustomLoadingOverlay loadingMessage="Loading..." />
                    ) : (
                      <AgGridReact
                        className="ag-grid-container" // Add a class for styling
                        domLayout="fixedHeight"
                        ref={gridRef} // Ref for accessing Grid's API
                        rowData={rowData} // Row Data for Row
                        columnDefs={columnDefs}
                        autoGroupColumnDef={autoGroupColumnDef}
                        defaultColDef={defaultColDef} // Default Column Properties
                        overlayLoadingTemplate={`<Loader />`}
                        animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                        rowSelection={'multiple'} // Options - allows click selection of rows
                        statusBar={statusBar}
                        sideBar={sideBar} // pass side by making interface
                        enableRangeSelection={true}
                        suppressExcelExport={true}
                        suppressRowClickSelection={true}
                        groupSelectsChildren={true}
                        pivotPanelShow={'always'}
                        popupParent={popupParent}
                        sortingOrder={sortingOrder}
                        onFirstDataRendered={onFirstDataRendered}
                        onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                        rowDragManaged={true}
                        suppressMoveWhenRowDragging={true}
                        rowGroupPanelShow={'always'}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Calls;
